module.exports = __webpack_public_path__ + "media/images/gear-db33debc418e2cf97501a199c10c9383.svg";